import { useAuth } from "../../../context/AuthContext";
import { dictionary } from "../../../utils/dictionary";

interface ImportProductFromLinkProps {
  isLoading: boolean;
  productLink: string;
  handleProductLinkChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error: string;
}

export function ImportProductFromLink({ isLoading, productLink, handleProductLinkChange, error }: ImportProductFromLinkProps) {
  const { language } = useAuth();
  
  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[200px]">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
          <p className="text-gray-500 mt-4">{dictionary["searching-your-product"][language]}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      <div className="w-full">
        <style>{`
          .product-link-input:-webkit-autofill,
          .product-link-input:-webkit-autofill:hover,
          .product-link-input:-webkit-autofill:focus,
          .product-link-input:-webkit-autofill:active {
            -webkit-text-fill-color: #1f2937 !important;
            transition: background-color 5000s ease-in-out 0s;
          }
        `}</style>
        <input
          type="text"
          name="product-link"
          placeholder={dictionary["paste-product-url-placeholder"][language]}
          value={productLink}
          onChange={handleProductLinkChange}
          className="product-link-input w-full rounded-xl border border-gray-200 px-4 py-3 bg-white text-base text-gray-900 placeholder-gray-500 focus:outline-none"
          style={{ width: "100%", boxSizing: "border-box" }}
        />
        {error && <p className="text-sm text-red-500 mt-2">{error}</p>}
      </div>
    </div>
  );
}

export default ImportProductFromLink;
